import { Container } from "react-bootstrap";

export default function Footer() {
  return (
    <footer className="border-top py-1">
      <Container>
        <small className="text-muted">
          &copy; {new Date().getFullYear()} Briefpoint{" "}
        </small>
      </Container>
    </footer>
  );
}
